import {Injectable} from '@angular/core';
import {GeneralService} from 'src/app/services/crud/general.service';
import {AlertService} from '../alert/alert.service';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {CustomActionContext} from '../data-table';
import {DialogComponent} from "libComm";
import {ALERT_TYPE} from "../alert/alert.enumerate";
import {MonitorService} from "../../../services/monitor.service";
import {ImportPreviewComponent} from "../import-preview/import-preview.component";
import {DndComponent} from "../dnd/dnd.component";
import {saveAs} from "file-saver";
import {BulkEditDialogComponent} from "../bulk-edit-dialog/bulk-edit-dialog.component";
import {cloneDeep} from "lodash";
import {AuditDialogComponent} from "../audit-dialog/audit-dialog.component";
import {DetailPageComponent} from "../detail-page/detail-page.component";
import {DialogUploadMonitorAttachmentComponent} from "../dialog-upload-monitor-attachment/dialog-upload-monitor-attachment.component";
import {MonitorNotificationComponent} from "../monitor-notification-component/monitor-notification.component";
import {takeUntil} from "rxjs";


@Injectable({
	providedIn: 'root'
})
export class CustomActionsService
{

	constructor(private generalService: GeneralService,
				private alertService: AlertService,
				public dialog: MatDialog,
				private translate: TranslateService,
				private monitorService: MonitorService)
	{
	}

	handleCustomAction(actionId: string, context?: CustomActionContext): void
	{
		if (actionId === "ACT_CLOSE") {
			this.close(context);
		}else if (actionId.endsWith("_MANUAL_ACTION")) {
			this.manualAction(actionId, context);
		}else if (actionId === "ACT_IMPORT_PREVIEW_ALL") {
			this.importPreviewAll(actionId, context);
		}else if (actionId === "ACT_EXPORT_CSV_ALL") {
			this.exportCsvAll(actionId, context);
		}else if (actionId === "ACT_BULK_EDIT_ALL") {
			this.bulkEdit(context);
		} else if(actionId ==="ACT_AUDIT"){
			this.audit(context);
		}else if(actionId === "ACT_SHOW_DETAIL"){
			this.showDetail(context);
		}else if(actionId === "ACT_INSP_CONTAINER"){
			this.showDetail(context);
		}else if(actionId.startsWith("ACT_MONITOR_UPLOAD_ATTACHMENT")){
			this.monitorUploadAttachment(actionId, context);
		}else if(actionId=== "ACT_COM_TRACKER") {
			this.openNotificationHistory(context);
		}else if(actionId.startsWith("ACT_VIEW_DUPLICATED")){
			this.viewDuplicated(actionId, context);
		}else if(actionId.startsWith("ACT_APPROVE")){
			this.approve(context);
		}else if(actionId.startsWith("ACT_OPEN")){
			this.open(context);
		}
		else {
			console.warn("There isn't handleCustomAction for: " + actionId);
		}

	}

	private close(context: CustomActionContext)
	{
		const mySelection: any [] = context.tableController.selection.selected;
		// get ids to approve
		const selectedIds: any [] = mySelection.map((row) => row["ID"]);
		context.tableController.selection.clear();
		const dialogRef = this.dialog.open(DialogComponent, {
			data: {
				title: "Confirm closing",
				content: `This action will close all selected records, proceed?`,
				cancelButtonLabel: "Cancel",
				cancelButtonColor: "basic",
				confirmButtonLabel: "Close",
				confirmButtonColor: "warn"
			}
		});

		dialogRef.afterClosed().subscribe((res) =>
		{
			if (!!res)
			{
				//this.onCloseRecordsClick.emit(ids);
				context.spinner.showWithTitle('data', this.translate.instant('LOADING_OPENING_PROCESS'))
				this.generalService.closeData(
					(!!context.apiUrl ? context.apiParent + "/" + context.apiUrl : context.apiParent),
					selectedIds).subscribe({
						next: (res) =>
						{

							context.reloadData();
							this.alertService.add({
								type: ALERT_TYPE.SUCCESS,
								message: this.translate.instant("RECORD_CLOSED"),
								timeout: 5000,
								selfClose: null
							});
						},
						error: (err) =>
						{
							context.spinner.hide();
							this.alertService.add({
								type: ALERT_TYPE.DANGER,
								message: this.translate.instant("RECORD_CLOSED_ERROR"),
								timeout: 5000,
								selfClose: null
							});
						},
						complete: () =>
						{
							context.spinner.hide();
						}
					}
				);
			}
		});
	}

	private manualAction(actionId: string, context?: CustomActionContext)
	{

		// ITOEM-5: added logic to handle manual action
		const realEventId = actionId.slice(0, -"_MANUAL_ACTION".length);
		const selectedRows = context.tableController.selection.selected.length > 0 ? context.tableController.selection.selected : [];
		const ids = selectedRows.map(row => row["ID"]);
		if (ids == null || ids.length == 0)
		{
			this.dialog.open(DialogComponent, {
				data: {
					title: "No row selected",
					content: `Please select at least 1 row...`,
					confirmButtonLabel: this.translate.instant("LABEL_OK"),
					confirmButtonColor: "basic"
				}
			});
			return;
		}
		this.monitorService.callManualAction(realEventId, ids).subscribe({
			next: res =>
			{
				if (res === 0)
				{
					this.alertService.add({
						type: ALERT_TYPE.SUCCESS,
						message: "Action executed.",
						timeout: 5000,
						selfClose: null
					});
				}
				else
				{
					this.alertService.add({
						type: ALERT_TYPE.WARNING,
						message: "Unable to execute the action.",
						timeout: 10000,
						selfClose: null
					});
				}
			},
			error: err =>
			{
				this.alertService.add({
					type: ALERT_TYPE.DANGER,
					message: "Internal action error.",
					timeout: 10000,
					selfClose: null
				});
			}
		})
	}

	private importPreviewAll(actionId: string, context?: CustomActionContext)
	{
		const dialogEvent = this.dialog.open(DndComponent, {
			data: {
				title: "UPLOADING",
				code: "Upload file: ",
				message: "Are you sure you want to upload this file?",
				btn: "Upload",
				type: "any",
				cancelBtn: "Close"
			}
		});

		dialogEvent.afterClosed().subscribe(async (dndResponse) =>
		{
			if (!!dndResponse && dndResponse.send)
			{
				const uploadFiles: File[] = dndResponse.files;

				for (let file of uploadFiles)
				{

					context.spinner.show();
					this.generalService.previewExcel(
						context.apiParent + "/" + context.apiUrl + "/import/preview",
						file
					).subscribe({
						next: res =>
						{
							context.spinner.hide();
							this.dialog.open(ImportPreviewComponent, {
								width: '65vw',
								height: '80vh',
								maxWidth: '100vw',
								data: {
									layout: res.oContent,
									apiParent: context.apiParent,
									apiUrl: context.apiUrl
								}
							}).afterClosed().subscribe((res) =>
								{
									context.reloadData();
								}
							);
						},
						error: err =>
						{
							context.spinner.hide();
						}
					})
				}
			}
		});
	}

	private exportCsvAll(actionId: string, context?: CustomActionContext)
	{
		if (context.tableController.numElementsSize > 5000)
		{
			const dialogRef = this.dialog.open(DialogComponent, {
				data: {
					title: this.translate.instant("LABEL_LARGE_AMOUNT_DATA"),
					content: this.translate.instant("LABEL_LARGE_AMOUNT_DATA_CONFIRM"),
					cancelButtonLabel: this.translate.instant("ACT_NO"),
					cancelButtonColor: "basic",
					confirmButtonLabel: this.translate.instant("ACT_YES"),
					confirmButtonColor: "warn"
				}
			});
			dialogRef.afterClosed().subscribe((res) =>
			{
				if (res)
				{
					let isCsv = false;
					if (actionId.startsWith("ACT_EXPORT_CSV"))
					{
						isCsv = true;
					}
					context.spinner.show();
					this.generalService.exportDataExcel(
						context.apiParent + "/" + context.apiUrl,
						isCsv ? "csv" : "excel",
						context.savedParams.set(
							"dataset",
							context.layout!["sectionLayouts"].filter((sectionLayout) => sectionLayout.id == "LYO_SECTABLE").pop()?.dataset[0].id ?? ""
						),
						[]
					).subscribe((blob) =>
					{
						// [REF]

						if (blob instanceof Blob)
						{
							saveAs(blob, `${context.titlePage}.${isCsv ? "csv" : "xlsx"}`);
						}
						else
						{
							console.error('Received data is not a Blob');
						}
						context.spinner.hide();
					});
				}
			});
		}
		else
		{
			context.spinner.show();
			let isCsv = false;
			if (actionId.startsWith("ACT_EXPORT_CSV"))
			{
				isCsv = true;
			}

			const defaultLanguage: string = "en";
			const language: string = localStorage.getItem('selectedLanguage') ?? defaultLanguage; //Id of the language

			this.generalService.exportDataExcel(
				//this.apiParent + "/" + this.apiUrl,
				(!!context.apiUrl ? context.apiParent + "/" + context.apiUrl : context.apiParent),
				isCsv ? "csv" : "excel",
				context.savedParams.set(
					"dataset",
					context.layout!["sectionLayouts"].filter((sectionLayout) => sectionLayout.id == "LYO_SECTABLE").pop()?.dataset[0].id ?? ""
				).set("lang", language),
				[]
			).subscribe((blob) =>
			{
				// [REF]
				if (blob instanceof Blob)
				{
					saveAs(blob, `${context.titlePage}.${isCsv ? "csv" : "xlsx"}`);
				}
				else
				{
					console.error('Received data is not a Blob');
				}
				context.spinner.hide();
			});
		}
	}

	private bulkEdit(context: CustomActionContext)
	{
		const selectedRows: any[] = context.tableController.selection.selected;

		if (!selectedRows || selectedRows.length === 0)
		{
			this.dialog.open(DialogComponent, {
				data: {
					title: "No row selected",
					content: `Please select at least 1 row...`,
					confirmButtonLabel: "Ok",
					confirmButtonColor: "basic"
				}
			});
			return;
		}

		const dialogRef = this.dialog.open(BulkEditDialogComponent, {
			data: {
				pageId: context.pageId,
				selectedRows: selectedRows,
				tableController: context.tableController,
				apiParent: context.apiParent,
				apiUrl: context.apiUrl
			}
		});

		dialogRef.afterClosed().subscribe(result =>
		{
			if (result === true)
			{
				context.reloadData();
			}
		});
	}

	private audit(context: CustomActionContext){
		context.tableController.reloadRow(context.rowIndex, false);
		const rowNumber = cloneDeep(context.tableController.rowNumber);
		context.tableController.rowNumber = -1;
		const committedRow = cloneDeep(context.tableController.dataSet[rowNumber]);
		let id = committedRow.ID;
		this.dialog.open(AuditDialogComponent, {
			width: '80vw',
			data: {
				title: "Audit details",
				info: id,
				closeButtonLabel: "Close"
			}
		});
	}

	private showDetail(context: CustomActionContext)
	{
		// retrieve monitor ID and pass it to the detail component
		const id = context.tableController.dataSet[context.rowIndex].ID;

		this.dialog.open(DetailPageComponent, {
			width: '65vw',
			height: '80vh',
			maxWidth: '100vw',
			data: {
				pageId: context.pageId,
				actionSet: context.actionsets,
				id: id
			}
		});
	}

	private monitorUploadAttachment (actionId: string,  context: CustomActionContext){

			const detailId = actionId.slice("ACT_MONITOR_UPLOAD_ATTACHMENT".length + 1);
			const uploadAttachment = this.dialog.open(DialogUploadMonitorAttachmentComponent, {
				data: {
					id: detailId,
					apiUrl: context.apiUrl,
					apiParent: context.apiParent
				}
			});
			uploadAttachment.afterClosed().subscribe(async (result) =>
			{
				if (!!result && result.send)
				{
					this.monitorService.uploadMonitoAttachmentFile(detailId, result.extraData, result.files).subscribe((res) =>
					{
						if (!!res)
						{
							context.reloadData();
						}
					});

				}
			});

		}

	private openNotificationHistory(context: CustomActionContext)
	{
		// retrieve monitor ID and pass it to the detail component
		const id = context.tableController.dataSet[context.rowIndex].ID;
		const container = context.tableController.dataSet[context.rowIndex].CONTAINER;

		this.dialog.open(MonitorNotificationComponent, {
			width: '65vw',
			// height: '50vw',
			data: {
				actionsets: context.actionsets,
				monitorId: id,
				container: container,
				apiParent: 'detail',
				apiUrl: 'monitor'
			}
		});
	}

	private viewDuplicated(actionId: string, context: CustomActionContext){
		const viewDuplicatedContainerOnly: boolean = actionId.endsWith("true");
		const extraParam = new Map<string, string | number | boolean>();
		extraParam.set('viewDuplicatedContainerOnly', viewDuplicatedContainerOnly);
		context.reloadData(extraParam);
	}

	private approve(context: CustomActionContext){
		if (context.tableController.selection.selected.length > 0)
		{
			const mySelection: any [] = context.tableController.selection.selected;
			context.spinner.showWithTitle('data', this.translate.instant('LOADING_APPROVE_PROCESS'))
			// get ids to approve
			const selectedIds: any [] = mySelection.map((row) => row["ID"]);
			this.generalService.approveData(
				(!!context.apiUrl ? context.apiParent + "/" + context.apiUrl : context.apiParent),
				selectedIds).subscribe({
					next: (res) =>
					{
						context.tableController.selection.clear();
						context.reloadData();
						let recordUpdated = selectedIds.length - res.length;
						res.map(message =>
						{
							this.alertService.add({
								type: ALERT_TYPE.WARNING,
								message: message,
								timeout: 20000,
								selfClose: null
							});
						});
						if (recordUpdated > 0)
						{
							if (recordUpdated == selectedIds.length)
							{
								if (res.length == 0)
								{
									this.alertService.add({
										type: ALERT_TYPE.SUCCESS,
										message: this.translate.instant("PREVIEW_FULL_APPROVE"),
										timeout: 20000,
										selfClose: null
									});
								}
							}
							else
							{
								this.alertService.add({
									type: ALERT_TYPE.SUCCESS,
									message: this.translate.instant("PREVIEW_PARTIAL_APPROVE"),
									timeout: 5000,
									selfClose: null
								});
							}
						}
					},
					error: (err) =>
					{
						this.alertService.add({
							type: ALERT_TYPE.DANGER,
							message: this.translate.instant("PREVIEW_UPDATE_ERROR"),
							timeout: 5000,
							selfClose: null
						});
					},
					complete: () =>
					{
						context.spinner.hide();
					}
				}
			);
		}
	}

	private open (context: CustomActionContext){
		if (context.tableController.selection.selected.length > 0)
		{
			const mySelection: any [] = context.tableController.selection.selected;
			context.spinner.showWithTitle('data', this.translate.instant('LOADING_OPENING_PROCESS'))
			// get ids to approve
			const selectedIds: any [] = mySelection.map((row) => row["ID"]);
			context.tableController.selection.clear();
			this.generalService.openData(
				(!!context.apiUrl ? context.apiParent + "/" + context.apiUrl : context.apiParent),
				selectedIds).subscribe({
					next: (res) =>
					{
						context.tableController.selection.clear();
						context.reloadData();
						let recordUpdated = selectedIds.length - res.length;
						res.map(message =>
						{
							this.alertService.add({
								type: ALERT_TYPE.WARNING,
								message: message,
								timeout: 20000,
								selfClose: null
							});
						});
						if (recordUpdated > 0)
						{
							if (recordUpdated == selectedIds.length)
							{
								if (res.length == 0)
								{
									this.alertService.add({
										type: ALERT_TYPE.SUCCESS,
										message: this.translate.instant("ALL_OPENED"),
										timeout: 20000,
										selfClose: null
									});
								}
							}
							else
							{
								this.alertService.add({
									type: ALERT_TYPE.SUCCESS,
									message: this.translate.instant("PARTIALLY_OPENED"),
									timeout: 5000,
									selfClose: null
								});
							}
						}
					},
					error: (err) =>
					{
						this.alertService.add({
							type: ALERT_TYPE.DANGER,
							message: this.translate.instant("PREVIEW_UPDATE_ERROR"),
							timeout: 5000,
							selfClose: null
						});
					},
					complete: () =>
					{
						context.spinner.hide();
					}
				}
			);
		}
	}

}
